import React from 'react';
import { Options } from 'ps-design';
import { Facet } from './types';
import './RadioButtonFacet.scss';

export interface RadioButtonFacetProps {
    facet: Facet;
    selection: string;
    facetDistinctItemClick: (facet: Facet, newSelection: string) => void;
}

const RadioButtonFacet = (props: RadioButtonFacetProps) => {
  const { facet, selection, facetDistinctItemClick } = props;

  const handleClick = (_optionId: string, newValue: string) => {
    facetDistinctItemClick(facet, newValue);
  };

  return (
    <Options
      id={facet.id}
      options={facet?.items?.map(i => i.key)}
      type="radio"
      value={[selection]}
      onChange={handleClick}
      multiValue={false}
      syncOptions={false}
      className="radio-button-facet"
    />
  );
};

export { RadioButtonFacet };
export default RadioButtonFacet;
